import { FormControl, FormLabel, Input, Select } from '@chakra-ui/react';
import React, { useState } from 'react';

interface addVariationField {
  fieldData: any;
  dropDownOptions: any;
  handleChangeDefaultValue: any;
}

function SingleVariationField({
  fieldData,
  dropDownOptions,
  handleChangeDefaultValue,
}: addVariationField) {
  return (
    <>
      <FormControl>
        <FormLabel>{fieldData.fieldname}:</FormLabel>
        {fieldData.type === 'checkbox' ? (
          <Select
            placeholder="Select item"
            value={fieldData.defaultvalue.replace('FIELD:', '')}
            onChange={e =>
              handleChangeDefaultValue(fieldData.fieldid, e.target.value)
            }
          >
            <option value="true">True</option>
            <option value="false">False</option>
          </Select>
        ) : (
          <Select
            placeholder="Select item"
            value={fieldData.defaultvalue.replace('FIELD:', '')}
            onChange={e =>
              handleChangeDefaultValue(fieldData.fieldid, e.target.value)
            }
          >
            {dropDownOptions.map((dropDownOption: any, index: number) => (
              <option key={index} value={dropDownOption.value}>
                {dropDownOption.name}
              </option>
            ))}
          </Select>
        )}
      </FormControl>
    </>
  );
}

export default SingleVariationField;
